var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "foot b_white" }, [
    _vm._m(0),
    _c("div", { staticClass: "w1200 t_center" }, [
      _vm._m(1),
      _c("div", { staticClass: "f_line" }),
      _c("div", { staticClass: "box35" }),
      _c("div", { staticClass: "f_codelie clear yahei pad10_l" }, [
        _c("div", { staticClass: "t_left pull-left" }, [
          _c("h2", { staticClass: "normal f18" }, [_vm._v("进货指南")]),
          _c("ul", [
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/memberregistGuide.do"
                  }
                },
                [_vm._v("用户注册")]
              )
            ]),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/shoppingprocessGuide.do"
                  }
                },
                [_vm._v("购物流程")]
              )
            ]),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/commonproblemGuide.do"
                  }
                },
                [_vm._v("常见问题")]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "t_left pull-left" }, [
          _c("h2", { staticClass: "normal f18" }, [_vm._v("支付方式")]),
          _c("ul", [
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/payment1Type.do"
                  }
                },
                [_vm._v("在线支付")]
              )
            ]),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/payment2Type.do"
                  }
                },
                [_vm._v("线下结算")]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "t_left pull-left" }, [
          _c("h2", { staticClass: "normal f18" }, [_vm._v("配送服务")]),
          _c("ul", [
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/distribution1Service.do"
                  }
                },
                [_vm._v("配送范围")]
              )
            ]),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/distribution2Service.do"
                  }
                },
                [_vm._v("自提服务")]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "t_left pull-left" }, [
          _c("h2", { staticClass: "normal f18" }, [_vm._v("售后保障")]),
          _c("ul", [
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/returnPolicy.do"
                  }
                },
                [_vm._v("退换政策")]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "t_left pull-left" }, [
          _c("h2", { staticClass: "normal f18" }, [_vm._v("商家合作")]),
          _c("ul", [
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/processEnter.do"
                  }
                },
                [_vm._v("商家入驻")]
              )
            ]),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 st gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/goods/tofootindex/basicRules.do"
                  }
                },
                [_vm._v("平台规则")]
              )
            ]),
            _c("li", [
              _c(
                "a",
                {
                  staticClass: "f14 st gray_3",
                  attrs: {
                    target: "_blank",
                    href:
                      _vm.origin.VUE_APP_APP +
                      "/operationCenter/toOperationCenter.do"
                  }
                },
                [_vm._v("运营中心申请")]
              )
            ])
          ])
        ]),
        _vm._m(2)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "w1200 clearfix", attrs: { id: "hideAD" } },
      [
        _c("a", { attrs: { href: "javascript:;" } }, [
          _c("img", {
            attrs: { src: require("./images/1200-120.jpg?v=1619654438100") }
          })
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticClass: "clearfix text-center" }, [
      _c("li", [
        _c("span", { staticClass: "f20 yahei gray_3 icon0" }, [
          _vm._v("名牌汇聚")
        ])
      ]),
      _c("li", [
        _c("span", { staticClass: "f20 yahei gray_3 icon1" }, [
          _vm._v("优质优价")
        ])
      ]),
      _c("li", [
        _c("span", { staticClass: "f20 yahei gray_3 icon2" }, [
          _vm._v("特级服务")
        ])
      ]),
      _c("li", [
        _c("span", { staticClass: "f20 yahei gray_3 icon3" }, [
          _vm._v("正品保障")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pull-left pad70_l" }, [
      _c("div", { staticClass: "f_codeimg1 pull-right pad70_l" }, [
        _c("img", {
          attrs: { src: require("./images/codeimg1.jpg?v=1619654438100") }
        }),
        _c("p", { staticClass: "f14 st gray_3 text-center" }, [
          _vm._v("农信商城微信")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }